<ion-header class="remove-margin-from-safe-area ion-no-border" *ngIf="loaded">
  <ion-toolbar >
    <ion-grid>
      <ion-row>
        <ion-col>
          <ion-toolbar>
          <ion-buttons slot="end">
            <ion-button (click)="closeModal()" 
              ><ion-icon  color="dark" name="close"></ion-icon
            ></ion-button>
          </ion-buttons>
        </ion-toolbar>
        </ion-col>
      </ion-row>
      <ion-row >
        <ion-col style="text-align: center;">
          <h2 class="subheader-regular"> {{ permitsSRV.permit.value['permit'].Lot.LotName }}</h2>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col class="ion-no-padding" style="text-align: center">
          <ion-label  class="card-text-regular"
            >{{ ('keys.data.permits.standard_permit' |
            translate : {Default:'Standard Permit'}) || 'Standard Permit' }}</ion-label >
        </ion-col>
      </ion-row>
      
      
    </ion-grid>
    
   
  </ion-toolbar>
</ion-header>
<ion-content>
  <app-pagecontent
    [path]="'permits/standard/reservation/' + lotNameId"></app-pagecontent>
  <ion-card *ngIf="!loaded">
    <ion-grid>
      <ion-row>
        <ion-col size="12">
          <h1 style="text-align: center; font-weight: bold; color: black">
            <ion-skeleton-text animated style="width: 60%"></ion-skeleton-text>
          </h1>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col>
          <h2 style="text-align: center">
            <ion-skeleton-text animated style="width: 60%"></ion-skeleton-text>
          </h2>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col class="single-col-wider">
          <ion-card-content>
            <ion-card>
              <ion-grid>
                <ion-row>
                  <ion-col style="text-align: center">
                    <ion-chip>
                      <ion-label>
                        <ion-skeleton-text
                          animated
                          style="width: 40%"
                        ></ion-skeleton-text
                      ></ion-label>
                    </ion-chip>
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col>
                    <ion-card>
                      <ion-item lines="none">
                        <ion-label>
                          <ion-skeleton-text
                            animated
                            style="width: 20%"
                          ></ion-skeleton-text
                        ></ion-label>
                        <ion-label style="text-align: right">
                          <ion-skeleton-text
                            animated
                            style="width: 60%"
                          ></ion-skeleton-text>
                        </ion-label>
                      </ion-item>
                    </ion-card>
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col>
                    <ion-item lines="none">
                      <ion-label>
                        <ion-skeleton-text
                          animated
                          style="width: 60%"
                        ></ion-skeleton-text>
                      </ion-label>
                      <ion-label style="text-align: right">
                        <ion-skeleton-text
                          animated
                          style="width: 60%"
                        ></ion-skeleton-text>
                      </ion-label>
                    </ion-item>
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col>
                    <ion-item lines="none">
                      <ion-label>
                        <ion-skeleton-text
                          animated
                          style="width: 60%"
                        ></ion-skeleton-text>
                      </ion-label>
                      <ion-label style="text-align: right">
                        <ion-skeleton-text
                          animated
                          style="width: 60%"
                        ></ion-skeleton-text>
                      </ion-label>
                    </ion-item>
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col>
                    <ion-item lines="none" style="font-weight: bold">
                      <ion-label>
                        <ion-skeleton-text
                          animated
                          style="width: 60%"
                        ></ion-skeleton-text>
                      </ion-label>
                      <ion-label style="text-align: right">
                        <ion-skeleton-text
                          animated
                          style="width: 60%"
                        ></ion-skeleton-text>
                      </ion-label>
                    </ion-item>
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col size="8" offset="2">
                    
                      <ion-skeleton-text
                        animated
                        style="width: 60%"
                      ></ion-skeleton-text>
                    
                  </ion-col>
                </ion-row>
              </ion-grid>
            </ion-card>
          </ion-card-content>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-card>
  <div
   
    *ngIf="loaded"
   
  >
    <ion-grid
      class="ion-no-padding"
      *ngIf="
        permitsSRV.permit.value['status'] == 'success' ||
        (permitsSRV.permit.value['status'] == 'error' &&
          permitsSRV.permit.value['permit']['error'] == errors.SOLD_OUT) ||
        (permitsSRV.permit.value['status'] == 'error' &&
          permitsSRV.permit.value['permit']['error'] ==
            errors.ALREADY_HAS_PERMIT) ||
        (permitsSRV.permit.value['status'] == 'error' &&
          permitsSRV.permit.value['message'] == errors.ALREADY_ON_WAITING_LIST)
      "
    >
    <ion-row *ngIf="permitsSRV.permit.value?.permit?.Lot?.Location">
      <ion-col  style="text-align: center" class="ion-padding">
        <div #divs>
          <div  class="permitDescription" >
          <ion-label >
            {{permitsSRV.permit.value?.permit?.Lot?.Location}}
          </ion-label>
        </div>
          <ion-label  style="color: var(--Red-Shade, #A02021);text-decoration: underline;font-weight: bold;cursor: pointer;"
          
          (click)="showMore($event)">Show more</ion-label>
          <ion-label  style="color: var(--Red-Shade, #A02021); text-decoration: underline;font-weight: bold;cursor: pointer;"   (click)="showLess($event)">Show less</ion-label>
          </div>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col style="text-align: center">
        <ion-chip style="--background:rgba(126, 234, 151, 0.50);--color:var(--Green-shade, #376642);font-weight: bold;">
          {{ ('keys.data.permits.sale_window' | translate : {Default:'Sale Window'}) ||
            'Sale Window' }} {{
            permitsSRV.permit.value['permitWindowTypes'][
            permitsSRV.permit.value['permit'].Lot.LotType ]
            }}</ion-chip>
      </ion-col>
    </ion-row>
      <ion-row>
        <ion-col  class="ion-no-padding single-col-wider">
          <ion-card class="card-shadow-7">
              <ion-grid>
                <ion-row *ngIf="permitsSRV.permit.value['permit']['prorated']">
                  <ion-col>
                    <div style="text-align: center">
                      <ion-chip color="success"> {{ ('keys.data.common.prorated' | translate : {Default:'Prorated'}) ||
                        'Prorated' }}</ion-chip>
                        </div>
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col>
                    <ion-item class="paragraph-bold"
                    *ngFor="let item of permitsSRV.permit.value['items']"
                    lines="none"
                  >
                  
                    <ion-label> {{ item.label }}  </ion-label>
                    <span style="text-align: right">
                      {{ item.price | currency }}
                    </span>
                  </ion-item>
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col>
                    <ion-item lines="none" class="paragraph-input-fields-regular">
                      <ion-label>
                        {{ ('keys.data.common.subtotal' | translate : {Default:'Subtotal'}) ||
                        'Subtotal' }}
                      </ion-label>
                      <span style="text-align: right">
                        {{ permitsSRV.permit.value['dollarvalues'].subtotal |
                        currency }}
                      </span>
                    </ion-item>
                  </ion-col>
                </ion-row>
                <ion-row *ngFor="let tax of permitsSRV.permit.value?.totals?.taxes">
                  <ion-col>
                    <ion-item lines="none" class="paragraph-input-fields-regular">
                      <ion-label>
                        {{ tax?.label  }} {{ tax?.percentage | round:3 }}%
                      </ion-label>
                      <span style="text-align: right">
                        {{ tax?.amount|
                          currency}}
                      </span>
                    </ion-item>
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col>
                    <ion-item lines="none" class="paragraph-input-fields-bold">
                      <ion-label>
                        {{ ('keys.data.common.total_owing' | translate : {Default:'Total Owing'}) ||
                        'Total Owing' }}
                      </ion-label>
                      <ion-label style="text-align: right">
                        {{ permitsSRV.permit.value['dollarvalues'].total |
                        currency }}
                      </ion-label>
                    </ion-item>
                  </ion-col>
                </ion-row>
               
              </ion-grid>
            </ion-card>
        </ion-col>
      </ion-row>
      
         
          
    </ion-grid>
    <ion-grid>
      <ion-row *ngIf="permitsSRV.permit.value['status'] == 'success' && loaded">
        <ion-col class="ion-text-center">
          <ion-button
            (click)="onReservePermit()"
            color="primary"
            
            
          >
            {{ ('keys.data.permits.reserve_permit' | translate : {Default:'Reserve Permit'}) ||
            'Reserve Permit' }}
          </ion-button>
        </ion-col>
      </ion-row>
      <ion-row *ngIf="permitsSRV.permit.value['status'] == 'error'">
        <ion-col style="text-align: center" class="ion-text-center">
          <ion-button 
            disabled
            color="primary"
            
            
          >
            {{ ('keys.data.permits.error_cannot_reserve' | translate : {Default:'Cannot reserve the permit'})
            || 'Cannot reserve the permit' }}
          </ion-button>
          </ion-col>
          </ion-row>
          <ion-row *ngIf=" permitsSRV.permit.value['status'] == 'error'">
            <ion-col size="12">
              <ion-item lines="none" class="paragraph-regular">
            <ion-icon color="danger" name="information-circle"></ion-icon>
              <ion-label
              class="paragraph-input-fields-regular"
                *ngIf="
          permitsSRV.permit.value['permit']['error'] ==
          errors.ALREADY_HAS_PERMIT
        "
              >
                {{ ('keys.data.permits.error_already_has_permit' |
                translate : {Default:'You already have a permit. The lot you have
                selected does not allow a secondary permit.'}) || 'You already have a permit. The lot you have
                selected does not allow a secondary permit.' }}
              </ion-label>
              <ion-label
              class="paragraph-input-fields-regular"
              *ngIf="
                permitsSRV.permit.value['permit']['error'] ==
                errors.SOLD_OUT
              "
            >
              {{ ('keys.data.permits.error_lot_sold_out' | translate : {Default:'The lot you have selected is sold out.'}) ||
              'The lot you have selected is sold out.' }}
            </ion-label>
            <ion-label
            class="paragraph-input-fields-regular"
            *ngIf="
              (permitsSRV.permit.value['permit']['error'] ==
                errors.LOT_NOT_AVAILABLE ||
                permitsSRV.permit.value['permit']['error'] ==
                  errors.LOT_NOT_VISIBLE) 
            "
          >
            {{ ('keys.data.permits.error_lot_not_available' |
            translate : {Default:'The lot you have selected is not available.
            Please click back and try another lot.'}) || 'The lot you have selected is not available.
            Please click back and try another lot.' }}
          </ion-label>
            </ion-item>
            </ion-col>
          </ion-row>
    </ion-grid>
  </div>
</ion-content>
